const STORAGE_KEY = 'baoks-cart-decision-timer-deadline';

class CartDecisionTimer extends HTMLElement {
  #intervalId;
  #deadline;

  connectedCallback() {
    const durationSeconds = Number.parseInt(this.dataset.durationSeconds || '', 10);
    if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return;

    this.#deadline = this.#readOrCreateDeadline(durationSeconds);
    this.#update();

    if (this.#deadline > Date.now()) {
      this.#intervalId = window.setInterval(() => this.#update(), 1000);
    }
  }

  disconnectedCallback() {
    if (this.#intervalId) window.clearInterval(this.#intervalId);
  }

  #readOrCreateDeadline(durationSeconds) {
    try {
      const storedDeadline = Number.parseInt(window.sessionStorage.getItem(STORAGE_KEY) || '', 10);
      if (Number.isFinite(storedDeadline) && storedDeadline > 0) return storedDeadline;

      const deadline = Date.now() + durationSeconds * 1000;
      window.sessionStorage.setItem(STORAGE_KEY, String(deadline));
      return deadline;
    } catch (_error) {
      return Date.now() + durationSeconds * 1000;
    }
  }

  #update() {
    const display = this.querySelector('[data-cart-decision-timer-display]');
    const running = this.querySelector('[data-cart-decision-timer-running]');
    const complete = this.querySelector('[data-cart-decision-timer-complete]');
    const status = this.querySelector('[data-cart-decision-timer-status]');
    if (!display || !running || !complete) return;

    const remainingSeconds = Math.max(0, Math.ceil((this.#deadline - Date.now()) / 1000));
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    display.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    if (remainingSeconds > 0) return;

    running.hidden = true;
    complete.hidden = false;
    if (status) status.textContent = 'Die Entscheidungshilfe ist abgelaufen. Dein Warenkorb bleibt gespeichert.';
    if (this.#intervalId) window.clearInterval(this.#intervalId);
  }
}

if (!customElements.get('cart-decision-timer')) {
  customElements.define('cart-decision-timer', CartDecisionTimer);
}
